import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-request-uncomplete-modal',
  templateUrl: './request-uncomplete-modal.component.html',
  styleUrls: ['./request-uncomplete-modal.component.css']
})
export class RequestUncompleteModalComponent implements OnInit {
  @Input() public request: any;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

}
